import React from 'react'
import { Avatar } from '@deal/components'
import { ChatWidgetExpertFragment } from '#src/generated/graphql'
import classnames from 'classnames'
import styles from './styles.css'

export interface ChatHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  expert: ChatWidgetExpertFragment
  online?: boolean
  minimized?: boolean
  ctaIcon?: React.StatelessComponent<React.SVGAttributes<SVGElement>>
  ctaText?: string
  onCtaClick?: React.MouseEventHandler<HTMLDivElement>
}

export interface ChatHeaderState {
  alertNewMessage?: boolean
}

class ChatHeader extends React.Component<ChatHeaderProps, ChatHeaderState> {
  public timer?: NodeJS.Timer

  public constructor(props: ChatHeaderProps) {
    super(props)

    this.state = {}

    this.tick = this.tick.bind(this)
  }

  public componentDidMount() {
    this.timer = setInterval(this.tick, 2000)
  }

  public componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  public tick() {
    this.setState(prevState => ({
      alertNewMessage: !prevState.alertNewMessage
    }))
  }

  public render() {
    const {
      expert,
      className,
      minimized,
      online,
      ctaIcon,
      ctaText,
      onCtaClick,
      ...rest
    } = this.props

    const CtaIcon = this.props.ctaIcon

    return (
      <div
        className={classnames(styles.header, className, {
          [styles.minimized]: minimized
        })}
        {...rest}
      >
        <Avatar
          name={expert.displayName}
          src={
            expert.expertProfile && expert.expertProfile.profilePhoto
              ? expert.expertProfile.profilePhoto.url
              : undefined
          }
          size={48}
          className={styles.avatar}
        />

        <div className={styles.labels}>
          <div className={styles.title}>{expert.shortName}</div>
          {online && (
            <div className={styles.presence}>
              <span className={styles.presenceBadge} />
              <span className={styles.presenceText}>Online</span>
            </div>
          )}
        </div>

        {/* Render the CTA if an icon or text, or both, are provided */}
        {(ctaIcon || ctaText) && (
          <div
            className={styles.cta}
            onClick={e => {
              e.stopPropagation()
              onCtaClick && onCtaClick(e)
            }}
          >
            {CtaIcon && <CtaIcon className={styles.ctaIcon} />}
            {ctaText && <span className={styles.ctaText}>{ctaText}</span>}
          </div>
        )}
      </div>
    )
  }
}

export default ChatHeader
